import { render, staticRenderFns } from "./DetallePreventivaForm.vue?vue&type=template&id=68b2732c&scoped=true&"
import script from "./DetallePreventivaForm.vue?vue&type=script&lang=ts&"
export * from "./DetallePreventivaForm.vue?vue&type=script&lang=ts&"
import style0 from "./DetallePreventivaForm.vue?vue&type=style&index=0&id=68b2732c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b2732c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('68b2732c', component.options)
    } else {
      api.reload('68b2732c', component.options)
    }
    module.hot.accept("./DetallePreventivaForm.vue?vue&type=template&id=68b2732c&scoped=true&", function () {
      api.rerender('68b2732c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/HistoricoMantenimiento/DetallePreventivaForm.vue"
export default component.exports